<template>
	<header class="page-header" :class="colorTheme">
		<template v-if="isLeftButton">
			<button
				v-if="!isClose"
				class="back-button"
				:disabled="isLeftButtonDisabled"
				@click="handleBack"
			/>
			<button
				v-else
				class="btn-close"
				:disabled="isLeftButtonDisabled"
				@click="$emit('close')"
			/>
		</template>
		<template v-else>
			<div />
		</template>
		<span class="title">
			{{ title }}
			<span class="sub-title">{{ subTitle }}</span>
		</span>
		<div class="page-header-right-button">
			<slot name="rightButton" />
		</div>
	</header>
</template>

<script>
export default {
	name: 'PageHeader',
	props: {
		title: {
			type: String,
			default: ''
		},

		subTitle: {
			type: String,
			default: ''
		},

		isClose: {
			type: Boolean,
			default: false
		},

		isLeftButton: {
			type: Boolean,
			default: true
		},

		isLeftButtonDisabled: {
			type: Boolean,
			default: false
		},

		colorTheme: {
			type: String,
			default: ''
		}
	},

	methods: {
		handleBack() {
			this.$emit('go-back')
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.page-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-shrink: 0;
	padding: 4px 8px 4px 0;
	color: $white;
	background-color: $background-dark;

	&.white {
		position: relative;
		z-index: 3;
		padding: 13px 20px 13px 20px;
		background-color: $white;
		color: $grey-dark;
		box-shadow: 0px -1px 6px rgba($black, 0.16);

		.title {
			width: 100%;
			overflow: hidden;
			white-space: nowrap;
			text-align: center;
			font-size: 30px;
			font-weight: 300;
		}

		.btn-close,
		.back-button {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);

			&:after,
			&:before {
				border-color: $grey-dark;
			}
		}
	}

	.title {
		display: block;
		font-size: 20px;
		font-weight: 700;
		text-align: center;
	}

	.btn-close,
	.back-button {
		&:disabled {
			opacity: 0.5;
			cursor: default;
		}
	}

	.sub-title {
		display: block;
		font-size: 12px;
		opacity: 0.5;
	}
}

@media (max-width: 767px) {
	.page-header:not(.white) .title {
		font-size: 16px;
		line-height: 1.5;
	}
}
</style>
